import { createStandaloneToast } from '@chakra-ui/react';
import Cookies from 'js-cookie';

const { toast } = createStandaloneToast();

interface ErrorResponse {
    response?: {
        data?: {
            error?: string;
            details?: string;
            message?: string;
        };
    };
}

interface ToastMessage {
    title?: string;
    message?: string;
}

const showErrorToast = (error: ErrorResponse) => {
    toast({
        title: error.response?.data?.error || "Error",
        description: error.response?.data?.details || "An unexpected error occurred.",
        status: 'error',
        duration: 5000,
        isClosable: true,
        position: "bottom",
    });
};

const showCustomErrorToast = (
    arg1: string | ToastMessage,
    message?: string,
    duration = 5000,
    isClosable = true
) => {
    let title: string;
    let bodyMessage: string;

    if (typeof arg1 === 'object') {
        title = arg1.title || 'Error';
        bodyMessage = arg1.message || '';
    } else {
        title = arg1;
        bodyMessage = message || '';
    }

    toast({
        title: title,
        description: bodyMessage,
        status: 'error',
        duration: duration,
        isClosable: isClosable,
        position: "bottom",
    });
};



const showCustomSuccessToast = (success: string) => {
    toast({
        title: "Success",
        description: success || "Operation successful.",
        status: 'success',
        duration: 5000,
        isClosable: true,
        position: "bottom",
    });
};



export const getRelativeTime = (dateString: string): string => {
    // Convert current time to UTC for proper comparison with backend timestamps
    const now = new Date();
    const nowUtc = new Date(now.getTime() + (now.getTimezoneOffset() * 60000));
    const date = new Date(dateString);
    const diffInSeconds = Math.floor((nowUtc.getTime() - date.getTime()) / 1000);

    if (diffInSeconds < 60) {
        return 'just now';
    }

    const diffInMinutes = Math.floor(diffInSeconds / 60);
    if (diffInMinutes < 60) {
        return diffInMinutes === 1 ? '1 minute ago' : `${diffInMinutes} minutes ago`;
    }

    const diffInHours = Math.floor(diffInMinutes / 60);
    if (diffInHours < 24) {
        return diffInHours === 1 ? '1 hour ago' : `${diffInHours} hours ago`;
    }

    const diffInDays = Math.floor(diffInHours / 24);
    if (diffInDays < 7) {
        return diffInDays === 1 ? '1 day ago' : `${diffInDays} days ago`;
    }

    const diffInWeeks = Math.floor(diffInDays / 7);
    if (diffInWeeks < 4) {
        return diffInWeeks === 1 ? '1 week ago' : `${diffInWeeks} weeks ago`;
    }

    const diffInMonths = Math.floor(diffInDays / 30);
    if (diffInMonths < 12) {
        return diffInMonths === 1 ? '1 month ago' : `${diffInMonths} months ago`;
    }

    const diffInYears = Math.floor(diffInDays / 365);
    return diffInYears === 1 ? '1 year ago' : `${diffInYears} years ago`;
};

export const getCurrentTimestampEST = (): string => {
    const now = new Date();
    const estOffset = -5; // EST is UTC-5
    const estTime = new Date(now.getTime() + (estOffset * 60 * 60 * 1000));
    return estTime.toISOString();
};

export {
    showErrorToast,
    showCustomErrorToast,
    showCustomSuccessToast
}; 